import { ApiUrl } from '@common/enums';
import { EndCapProduct } from '@common/models';
import { easyEstimatorApi } from '@ee-api/easyEstimatorService';
import { CommonProductQueryParams } from '@ee-api/queryParams';

const endCapsService = easyEstimatorApi.injectEndpoints({
    endpoints: (builder) => ({
        fetchEndCap: builder.query<EndCapProduct[], CommonProductQueryParams>({
            query: ({ params }) => ({
                url: ApiUrl.LAMINATE_CAPS,
                method: 'GET',
                params,
            }),
        }),
    }),
});

export const { useFetchEndCapQuery, useLazyFetchEndCapQuery } = endCapsService;
